import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion, AccordionDetails, AccordionSummary, Badge, List, ListItem, Typography,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { EditorControls } from '../../../BaseEditor';

function BudgetsContainer({ budgets, onChange }) {
  const [opened, setOpened] = useState(false);
  const checkedCount = useMemo(
    () => budgets.filter((b) => b.checked).length,
    [budgets],
  );
  return (
    <Accordion expanded={opened} onChange={(e, v) => setOpened(v)}>
      <AccordionSummary expandIcon={(
        <FontAwesomeIcon icon={faChevronDown} />
      )}
      >
        <Badge badgeContent={checkedCount} color="secondary">
          <Typography sx={{ mr: 2 }}>
            Бюджети
          </Typography>
        </Badge>
      </AccordionSummary>
      <AccordionDetails>
        <List>

          {budgets.map((budget) => (
            <ListItem key={budget.id}>
              <EditorControls.CheckboxInput
                label={budget.repr}
                value={budget.checked}
                onChange={(e, v) => onChange(e, budgets.map(
                  (b) => (b.id === budget.id ? { ...b, checked: v } : b),
                ))}
              />
            </ListItem>
          ))}
        </List>

      </AccordionDetails>
    </Accordion>
  );
}

BudgetsContainer.propTypes = {
  budgets: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    repr: PropTypes.string,
    checked: PropTypes.bool,
  })).isRequired,
  onChange: PropTypes.func.isRequired,
};
export default BudgetsContainer;
